import { Button} from "nhsuk-react-components";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../../../Components/Loader/Loader";
import GoBack from "../../../../Components/Shared/GoBack";
import { GetObjectiveAndProcessing_URL } from "../../../../config/api-endpoints.config";
import { fetchInterceptor, getCookie, getTaskListType, submitSpinner } from "../../../../Helper/Utility";
import { IApiResObjectiveAndProcessing, IApplication, IPurpose } from "../../../../state/models/app.interface";
import { useAppDispatch, useAppSelector } from "../../../../state/app/hooks";
import { AppDispatch } from "../../../../state/app/store";
import { dsaContent, fileTypeSize, routeName } from "../../../../config/page.config";
import ControllerHeader from "../../../../Components/Shared/ControllerHeader";
import { getDSADetails } from "../../../../state/slice/DSA/DSA.slice";
import { getPurposeDetails, setPurposeDetailsData } from "../../../../state/slice/Purpose/Purpose.slice";
import ExpandCollapse from "../../../../Components/ExpandCollapse/ExpandCollapse";

const ObjectiveAndProcessingCheckYourAnswer: React.FC = () => {
    let navigate = useNavigate();
    const authenticationTokenCookie: string = getCookie('authenticationToken')!;
    const [loading, setLoading] = useState(false);
    const dispatch: AppDispatch = useAppDispatch();
    const dsaApplicationData: IApplication = useAppSelector(getDSADetails) || {};
    const purposeDetailsData: IPurpose = useAppSelector(getPurposeDetails);
    const initialState: IPurpose = purposeDetailsData || {};
    const [purposeData, setPurposeData] = useState(initialState);
    const savePurposeDataInStore = (stateData?: IPurpose) => {
        dispatch(setPurposeDetailsData({ ...purposeData, ...stateData }));
    }

    const getObjectiveAndProcessing = () => {
        setLoading(true);
        const parameters: string = JSON.stringify({
            "UserAuthTokenId": authenticationTokenCookie,
            "ApplicationId": dsaApplicationData.id !== "" ? dsaApplicationData.id : ""
        });
        const requestOptions: Object = {
            method: 'POST',
            headers: { 'Content-Type': fileTypeSize.fileTypeJson },
            body: parameters
        };
        fetchInterceptor(GetObjectiveAndProcessing_URL, requestOptions)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setObjectiveAndProcessing(data);
            })
            .catch(() => navigate(routeName.serviceError));
    }

    const setObjectiveAndProcessing = (response: IApiResObjectiveAndProcessing) => {
        let purpose: IPurpose = {};
        if (response) {
            purpose.objectiveForProcessing = response.ObjectiveForProcessing;
            purpose.processingActivities = response.ProcessingActivities;
            purpose.objectiveForProcessingCheckYourAnswerPage = "";
        }
        setPurposeData(purpose);
        savePurposeDataInStore(purpose);
        setLoading(false);
    }

    const handleCLick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, pageNavigation: string) => {
        e.preventDefault();
        let updatedState: IPurpose = {};
        updatedState = {
            ...purposeData,
            objectiveForProcessingCheckYourAnswerPage: pageNavigation
        }
        setPurposeData(updatedState);
        savePurposeDataInStore(updatedState);
        navigate(pageNavigation)
    }

    const navigateCompletedObjectiveProcessing = () => {
        navigate(routeName.completedObjectiveProcessing);
    }

    const handleClickContinue = (e: React.MouseEvent<HTMLButtonElement>) => {
        submitSpinner(e, navigateCompletedObjectiveProcessing);
    }

    useEffect(() => {
        getObjectiveAndProcessing();
    }, []);

    return (
        <>
            <ControllerHeader></ControllerHeader>
            <div className="nhsuk-width-container">
                <main className="nhsuk-main-wrapper " id="maincontent" role="main">
                    <div className="nhsuk-grid-row">
                        {loading ?
                            <Loader loadingText={dsaContent.txtLoading} />
                            :
                            <div className="nhsuk-grid-column-full">
                                {
                                    <GoBack condition={getTaskListType(dsaApplicationData.returningJourneyType!)} />
                                }
                                <h1><span className="nhsuk-caption-l nhsuk-caption--bottom ">
                                    Objective and processing activities</span>
                                    Check your answers
                                </h1>
                                <table role="table" className="nhsuk-table-responsive">
                                    <tbody className="nhsuk-table__body">
                                        <tr role="row" className="nhsuk-table__row">
                                            <th role="columnheader" scope="col">
                                                What is the objective(s) for processing the data?
                                            </th>
                                            <td role="cell" className="nhsuk-table__cell">
                                                {purposeData.objectiveForProcessing ? <ExpandCollapse content={purposeData.objectiveForProcessing!} /> : ""}
                                            </td>
                                            <td role="cell" className="nhsuk-table__cell">
                                                <a href="" aria-label="objectiveProcessing" onClick={(e) => handleCLick(e, routeName.objectiveProcessing)}>Change</a>
                                            </td>
                                        </tr>
                                        <tr role="row" className="nhsuk-table__row">
                                            <th role="columnheader" scope="col">
                                                Processing activities
                                            </th>
                                            <td role="cell" className="nhsuk-table__cell">
                                                {purposeData.processingActivities ? <ExpandCollapse content={purposeData.processingActivities!} /> : ""}
                                            </td>
                                            <td role="cell" className="nhsuk-table__cell">
                                                {<Link to={routeName.processingActivities}>Change </Link>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="nhsuk-u-padding-bottom-7"></div>
                                <Button name="Continue" id="nhsuk-button-spinner" onClick={handleClickContinue} >{dsaContent.btnTextContinue}</Button>
                            </div>
                        }
                    </div>
                </main>
            </div>
        </>)
}

export default ObjectiveAndProcessingCheckYourAnswer;